
import {Logic} from '../Type'
import {Main} from '../Main'
import {RouterObjects} from '../RouterObjects'

export function PageNotFound() {
    return(
        // Main.Instance.LoginState.Verified ?
        Logic.Type.New(Main.Instance, {Location: RouterObjects.index.path})
        // :Logic.Type.New(Main.Instance, {Location:RouterObjects["login"].path})
    )
}


// WEBPACK FOOTER //
// ./src/Logic/Router/PageNotFound.ts